const PUBLIC_GLIMMR_API_KEY = "280382648201";
const PUBLIC_ICON_URL = "https://glimmr.app/images/icon.png";
export {
  PUBLIC_ICON_URL as P,
  PUBLIC_GLIMMR_API_KEY as a
};
